import React, { Component } from 'react'
import { observer } from 'mobx-react'

import NewExploriAdminStore from './newExploriAdminStore'
import Button from '../../../../UniformComponents/Button'
import Panel from '../../../../UniformComponents/Panel'
import PanelHeader from '../../../../UniformComponents/PanelHeader'
import CheckboxGroup from '../../../form/CheckboxGroup'

import Checkbox from '../../../form/Checkbox'
import Input from '../../../form/Input'

@observer
class NewExploriAdmin extends Component {
    constructor(props) {
        super(props)

        const { store } = props

        this.newExploriAdminStore = new NewExploriAdminStore(store)
        store.breadcrumps = [
            {
                name: 'newExploriAdmin',
                url: '/intranet/newExploriAdmin',
                title: 'Create new Explori Admin',
            },
        ]
    }

    componentDidMount() {
        const { history } = this.props
        this.newExploriAdminStore.init(history)
    }

    renderFormFields = () => {
        const { formFields, changeFormField, register, unregister } = this.newExploriAdminStore

        return formFields.map((field) => {
            let elem
            switch (field.type) {
                case 'input':
                    elem = (
                        <Input
                            name={field.name}
                            label={field.label}
                            isMandatory={field.isMandatory}
                            register={register}
                            unregister={unregister}
                            onBlur={changeFormField}
                        />
                    )
                    break
                case 'CH':
                    elem = (
                        <Checkbox
                            name={field.name}
                            label={field.label}
                            isMandatory={field.isMandatory}
                            className="exploriNativeCheckbox"
                            onBlur={changeFormField}
                        />
                    )
                    break
                default:
                    elem = null
            }

            return (
                <div style={{ display: 'flex' }}>
                    {elem}
                </div>
            )
        })
    }

    render() {
        const {
            ready,
            clients,
            selectAll,
            changeclientIds,
            form,
            isSaving,
            save,
        } = this.newExploriAdminStore
        return (
            <div id="mergeFieldSearch" className="mergeFieldSearch">
                <div>
                    {ready
                    && (
                        <Panel>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <Panel style={{ boxShadow: 'none' }}>
                                    <PanelHeader>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <span>Client</span>
                                            <label htmlFor="selectAll" style={{ display: 'flex', gap: '10px', alignItems: 'center'}}>
                                                All Clients
                                                <Checkbox
                                                    onBlur={selectAll}
                                                    name="selectAll"
                                                    checked={form.clientId.length === 0}
                                                    className="exploriNativeCheckbox"
                                                />
                                            </label>
                                        </div>
                                    </PanelHeader>
                                    <div style={{ height: '400px', overflow: 'auto' }}>
                                        <CheckboxGroup
                                            key={`clientIds_${new Date().getTime()}`}
                                            options={clients}
                                            onBlur={changeclientIds}
                                            name="clientId"
                                            defaultChecked={form.clientId.slice()}
                                            refreshOnRender
                                            checkboxClassName="exploriNativeCheckbox"
                                        />
                                    </div>
                                </Panel>
                                {this.renderFormFields()}
                                <div>
                                    <Button
                                        disabled={isSaving}
                                        label="Save"
                                        onClick={save}
                                        cssClass="regular primary"
                                    />
                                </div>
                            </div>
                        </Panel>
                    )}
                </div>
            </div>
        )
    }
}

export default NewExploriAdmin
